<!-- <div id="about">
    <div class="container">
        <div class="d-flex row">
            <div class="col-lg-5 col-md-5 col-sm-5" >
                <div class="corner" >
                    <div class="heading">
                        <h2 style="flex-basis: 55%;">NEWS & EVENTS</h2>
                        <hr style="flex-basis: 45%;">
                    </div>
                    <div class="sub-head">
                        <hr class="part1">
                        <p>Here's the latest from R.P.D.A.V Public School</p>
                        <hr class="part2">
                    </div>
                </div>
                <div id="news-events">
                    <div class="row" style="width: 100%;">
                        <div class="col-lg-12 col-md-12 col-sm-12 p-0" >
                            <div class="border" id="news">
                                <div class="row">
                                    <marquee behavior="scroll" direction="up" scrollamount="6"  appMarqueeDirective #myNews *ngFor="let new of news;let i=index">
                                        <div class="row" class="text-center"  style="margin-bottom: 10px;" *ngFor="let new of news;let i=index" >
                                            <h3 class="mx-auto" style="color: #154360 ;width: 90%;" >{{new.description}}</h3>
                                            <a href="{{new.url}}" class="text-warning font-weight-bold"  target="_blank" download>Download</a>
                                            <hr class="pb-1 " style="width: 100%;background-color: #154360;">
                                        </div>
                                        
                                        </marquee>
                                </div>
                            </div>
                        </div>
                    </div>
                
                </div>
            </div>
            <div class="col-lg-7 col-md-7 col-sm-7">
                <h3 class="text-light">Welcome To R.P.D.A.V Public School</h3>
                <hr class="bg-light">
                <p class="lead text-light">The School aims at nurturing individuals with paramount values and multivalent competencies. This difficult and complex task is accomplished by virtue of a dynamic curriculum that envisions not only academic excellence, but aesthetic refinements, effective skills and the art of living.</p>
                <div class="d-flex row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div id="accordion">
                            <div class="card mb-1">
                                <div class="card-header">
                                    <h5 class="mb-0" href="#collapse1" 
                                        data-toggle="collapse">R.P.D.A.V SOCIETY<i class="fas fa-caret-down"></i>
                                    </h5>
                                </div>
                                    <div class="collapse" id="collapse1" data-parent="#accordion">
                                        
                                        <div class="card-body">
                                            Freemasonry is one of the world's oldest secular fraternal societies.
                                            It is a world-wide organisation based on the principle of the Fatherhood of God and the Brotherhood of man.
                                            <br>
                                            <button class="btn btn-warning mt-2" routerLink="/about/introduction">Read More</button>
                                        </div>
                                    </div>
                            </div>
                            <div class="card mb-1">
                                <div class="card-header">
                                    <h5 class="mb-0" href="#collapse2" 
                                        data-toggle="collapse">MISSION<i class="fas fa-caret-down"></i>
                                    </h5>
                                </div>
                                    <div class="collapse" id="collapse2" data-parent="#accordion">
                                    
                                        <div class="card-body">
                                            Masonic organisations throughout the world are engaged in many philanthropic and charitable projects.
                                             In India too, the Masonic Fraternity is involved in several charitable projects, all over the country.
                                            <br>
                                            <button class="btn btn-warning mt-2" routerLink="/about/introduction">Read More</button>
                                        </div>
                                    </div>
                            </div>
                            <div class="card mb-1">
                                <div class="card-header">
                                    <h5 class="mb-0" href="#collapse3" 
                                        data-toggle="collapse">PROMINENT FREEMASONS<i class="fas fa-caret-down"></i>
                                    </h5>
                                </div>
                                    <div class="collapse" id="collapse3" data-parent="#accordion">
                                    
                                        <div class="card-body">
                                            Swami Vivekananda (initiated in 1884 under the name of Bro. Narendra Nath Dutt in Lodge Anchor & Hope, Calcutta).
                                            <br>
                                            <button class="btn btn-warning mt-2" routerLink="/about/introduction">Read More</button>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</div> -->

<div id="about">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-md-8 about-detail">
                <div class="row">
                    <div class="col-12 text-center">
                        <h2 class="font-weight-bold">ABOUT US</h2>
                        <hr class=" p-1 mx-auto" style="width: 160px;">
                    </div>
                    <div class="col-12 about-detail-name">
                        <h3 class="font-weight-bold">Welcome To Ram Prasad D.A.V. Sr. Sec. Public School</h3>
                        <hr>
                        <p class="lead text-justify">
                            Our school aims at introducing value-based quality education in students.
                             I feel that every child is unique with latent qualities.
                              Our teachers do their best to find those qualities and pave the way for him to develop himself into an impressive personality.
                             Blended efforts of teachers and parents make the student never lose sight of his nurtured dream. 
                        </p>
                        
                        <p class="lead d-none d-lg-block text-justify">Students also should get the advantage of this opportunity and use their skills to perfection to become 'winning personalities' and complete human beings.</p>
                        <button class="btn btn-warning " routerLink="/about/intro">Read More</button>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4 about-img">
                <div class="event">
                    <h2 class="font-weight-bold">IMPORTANT NOTICES</h2>
                    <hr class=" p-1" style="width: 320px;">
                    <div class="event-data">
                        <div class="row">
                            <marquee behavior="scroll" direction="up" scrollamount="2" >
                                 <div class="row mb-3" *ngFor="let new of news;let i=index">
                                    <div class="col-3 date text-center d-flex flex-column ">
                                       <div style="font-size: 30px;">{{new.day}}</div>
                                       <div style="margin-top: -15px;">{{new.month}}</div>
                                    </div>
                                    <div class="col-9 pl-0">
                                        <div class="detail w-75">
                                            {{new.title}} <br>
                                            {{new.description}} <br>
                                            <a class="colorHover" href="{{new.imgUrl}}" target="_blank" download *ngIf="(new.imgUrl && new.imgUrl != '#')">Download</a>
                                        </div>
                                    </div>
                                </div>
                            </marquee>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
